import { hydrateImages, debounce, loadStyles } from '@tools/slider_common.js';

function initializeSlickSlider(slider, mode) {
// mode: 'desktop' or 'mobile'

  hydrateImages(slider);

  const $nav = $('.reviews-slider .nav-buttons:visible');

  if (slider.hasClass('slick-initialized')) {
    slider.slick('unslick');
  }

  const isDesktop = mode === 'desktop';
  slider.slick({
    arrows: true,
    appendArrows: $nav,
    prevArrow: '<button type="button" class="slick-prev"><svg width="24" height="24" viewBox="0 0 24 24"><path d="M15 6l-6 6 6 6" stroke="#333" stroke-width="2" fill="none"/></svg></button>',
    nextArrow: '<button type="button" class="slick-next"><svg width="24" height="24" viewBox="0 0 24 24"><path d="M9 6l6 6-6 6" stroke="#333" stroke-width="2" fill="none"/></svg></button>',
    centerMode: false,
    slidesPerRow: 1,
    respondTo: 'window',
    slidesToShow: isDesktop ? 2 : 1,
    rows: isDesktop ? 2 : 1
  });
}

export function openModal(text, author) {
  const modal = document.createElement('div');
  modal.classList.add('basic-modal', 'card-modal', 'modal-active');
  modal.innerHTML = `
    <div class='content'>
      <div class='line'>
        <img class='logo' src='/static/img/5p-logo-no-bg-width-100.webp' title='5 Points moving company, LA - logo' alt='5 Points moving company, LA - logo' loading='lazy'>
        <span class='close'>&times;</span>
      </div>
      <p class='text'>${text}</p>
      <p class='author'>${author}</p>
    </div>
  `;
  document.body.appendChild(modal);
  body.classList.add('blocked');

  modal.querySelector('.close').addEventListener('click', () => {
    modal.remove();
    body.classList.remove('blocked');
  });
  modal.addEventListener('click', (e) => {
    if (e.target === modal)
      modal.remove();
      body.classList.remove('blocked');
  });
}

function applyModeByWidth(slider){
  const w = window.innerWidth;
  const currentRows = slider.hasClass('slick-initialized') ? slider.slick('getSlick').options.rows : null;

  if (w <= 768 && currentRows !== 1) {
    if (slider.hasClass('slick-initialized')) {
      slider.slick('unslick');
    }
    initializeSlickSlider(slider, 'mobile');
  }

  if (w > 768 && currentRows !== 2) {
    if (slider.hasClass('slick-initialized')) {
      slider.slick('unslick');
    }
    initializeSlickSlider(slider, 'desktop');
  }

  addCardsOpenModalListener('.reviews-slider');
}

export function addCardsOpenModalListener(parentBlock) {
  document.querySelectorAll(`${parentBlock} .card`).forEach(card => {
    const cardText = card.querySelector('.text');
    // додаємо listener, якщо ще немає
    if (!card._listenerFn) {
      const cardAuthor = card.querySelector('.author');
      card._listenerFn = () => openModal(cardText.textContent.trim(), cardAuthor.textContent.trim());
      card.addEventListener('click', card._listenerFn);
    }

    if (cardText.scrollHeight > cardText.clientHeight) {
      card.classList.add('clickable');
    } else {
      card.classList.remove('clickable');
      if (card._listenerFn) {
        card.removeEventListener('click', card._listenerFn);
        delete card._listenerFn; // прибираємо посилання
      }
    }
  });
}

function reviewsSliderHandler() {
  let slickSliderScript = document.querySelector('script[src="/static/slick-slider/slick.min.js"]');

  if (slickSliderScript) {
    const slider = $('.reviews-slider');
    applyModeByWidth(slider);

    $(window).on('resize', debounce(function(){
      applyModeByWidth(slider);
    }, 120));
  } else {
    loadStyles(['slick.css', 'slick-theme.css'], '/static/slick-slider/');
    slickSliderScript = document.createElement('script');
    slickSliderScript.src = '/static/slick-slider/slick.min.js';
    document.body.appendChild(slickSliderScript);

    slickSliderScript.onload = function () {
      const slider = $('.reviews-slider-body');
      applyModeByWidth(slider);

      $(window).on('resize', debounce(function(){
        applyModeByWidth(slider);
      }, 120));
    }
  }
}

export function reviewsSliderObserver() {
  const reviewsSlider = document.querySelector('.reviews-slider');

  if (reviewsSlider) {
    const reviewsSliderObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          reviewsSliderHandler();
          reviewsSliderObserver.disconnect();
        }
      });
    });
    reviewsSliderObserver.observe(reviewsSlider);
  }
}
